<template>
    <div class="_pt-0-24 _pb-0-24 _pr-0-16 _pl-0-16">
        <div class="h1 _mb-16 text-white">
            Получите подробную консультацию
        </div>
        <p class="_mb-40-24 text-white">
            Менеджер расскажет вам обо всех преимуществах и ответит на любые вопросы
        </p>
        <div class="_dflex _flexwrap _justify-content-between">
            <div v-if="isSended" class="_dflex _flex-none _flexdir-column _justify-content-center _min-h_full _w-592 _order-first  text-white">
                <div class="h1">
                    Спасибо, Ваш запрос принят!
                </div>
                <p class="p1">
                    Сотрудник банка свяжется с Вами в ближайшее время
                </p>
            </div>
            <form
                v-else
                class="_flex-none _w-592 _dgrid _grid-cols-2-1 _gap-32-24 _order-first"
                @submit.prevent
            >
                <ui-form-field
                    :value="$v.lastName.$model"
                    label="Фамилия"
                    dark
                    :errors="vuelidateErrorMesages.lastName"
                >
                    <template v-slot:default="{ id, errors }">
                        <UiTextInputSuggestions
                            :id="id"
                            :error="!!errors.length"
                            v-model="$v.lastName.$model"
                            :suggestionType="ESuggestionTypes.NAME"
                            :suggestionPatrs="[EFioParts.SURNAME]"
                            :count="3"
                            dark
                        />
                    </template>
                </ui-form-field>
                <ui-form-field
                    :value="$v.firstName.$model"
                    label="Имя"
                    dark
                    :errors="vuelidateErrorMesages.firstName"
                >
                    <template v-slot:default="{ id, errors }">
                        <UiTextInputSuggestions
                            :id="id"
                            :error="!!errors.length"
                            v-model="$v.firstName.$model"
                            :suggestionType="ESuggestionTypes.NAME"
                            :suggestionPatrs="[EFioParts.NAME]"
                            :count="3"
                            dark
                        />
                    </template>
                </ui-form-field>
                <ui-form-field
                    :value="$v.phone.$model"
                    label="Телефон"
                    dark
                    :errors="vuelidateErrorMesages.phone"
                >
                    <template v-slot:default="{ id, errors }">
                        <ui-text-input-masked
                            :id="id"
                            :error="errors.length > 0"
                            v-model="$v.phone.$model"
                            v-phone
                            dark
                            mask="+7 ### ###-##-##"
                            placeholder="+7"
                            type="tel"
                        />
                    </template>
                </ui-form-field>
                <ui-form-field
                    class="_grid-col-span-2-1"
                    :errors="vuelidateErrorMesages.isAgree"
                    :value="$v.isAgree.$model"
                >
                    <template v-slot:default="{ id }">
                        <ui-checkbox
                            v-model="$v.isAgree.$model"
                            :id="id"
                            dark
                            class="_mt-16-0 _mb-16-0"
                        >
                            <template v-slot:label>
                                Я соглашаюсь с&nbsp;<a target="_blank" href="/upload/docs/cards/agreement.pdf" class="link">условиями&nbsp;использования персональных&nbsp;данных</a> и подтверждаю согласие на использование <a href="#" class="link" @click.stop.prevent="$modal.show('agreement_pep')">простой электронной подписи</a>
                            </template>
                        </ui-checkbox>
                    </template>
                </ui-form-field>
                <div class="_grid-col-span-2-1">
                    <button
                        class="button button_white"
                        type="button"
                        @click="tryToSend"
                    >
                        Получить консультацию
                    </button>
                </div>
                <div class="_grid-col-span-2-1 _dflex">
                    <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-16"></span>
                    <span class="p3 text-gray">Мы защищаем ваши персональные данные, не раскрываем их третьим лицам и не распространяем без Вашего согласия на это, если иное не предусмотрено законодательством</span>
                </div>
            </form>
            <div class="_pa-32-0 _flex-none _br-32 premium-form-callback__info _order-second">
                <div class="h3 _mb-24-16 text-white">
                    <span class="_mobile-hidden">Выделенная линия 24/7 для премиум-клиентов</span>
                    <span class="_desktop-hidden">Обратитесь на выделенную линию</span>
                </div>
                <div class="_dflex _mb-24-16">
                    <div class="_pa-8 _bg-gray-868 _br-8 _mr-16 _w-40 _h-40">
                        <div class="icon icon-phone_white icon_size-24" />
                    </div>
                    <div class=" text-white">
                        <div class="h3 _mb-8-4">
                            <a href="tel:+78007001701">8 800 700-17-01</a>
                        </div>
                        <div class="p1">
                            Круглосуточно и бесплатно по России
                        </div>
                    </div>
                </div>
                <div class="_dflex _mb-0-24">
                    <div class="_pa-8 _bg-gray-868 _br-8 _mr-16 _w-40 _h-40">
                        <div class="icon icon-phone_white icon_size-24" />
                    </div>
                    <div class=" text-white">
                        <div class="h3 _mb-8-4">
                            <a href="tel:+74957750013">+7 495 775-00-13</a>
                        </div>
                        <div class="p1">
                            Для звонков из-за границы
                        </div>
                    </div>
                </div>
                <div class="_bb-mobile _mb-0-24"></div>
                <div v-if="!isSended" class="h3 _desktop-hidden _mb-24  text-white">
                    Или закажите обратный звонок
                </div>
            </div>
        </div>

        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="phone"
            endpoint="premiumServiceCallForm"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="onSend"
        />

        <error-modal
            :value="!!errorText"
            @input="(val) => { if (!val) { errorText = ''; } }"
        >
            {{  errorText }}
        </error-modal>
    </div>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
import { cyrWithDash, onlyCyrSymbol, seemsDigitInPhone } from '../../assets/js/vue/validations';
import vuelidateMessages from '../../assets/js/vue/validationsMessages';
import { validationMixin } from 'vuelidate';
import axios from 'axios';
import { getCookie } from '../../assets/js/utils';
import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes';
import { EFioParts } from '../../assets/js/vue/utlis/useDadata/utils/EFioParts';
import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';

export default {
    name: 'PremiumFormCallback',
    mixins: [validationMixin],
    components: {
        UiTextInputSuggestions,
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            phone: '',
            isAgree: false,
            isSended: false,
            errorText: '',
            isLoading: false,
            modalSmsShow: false,
            url: '/rest/v1/universal-form',
            sessid: window.config.bitrix_sessid,
            ESuggestionTypes,
            EFioParts
        };
    },
    validations() {
        return {
            lastName: {
                required,
                cyrWithDash,
            },
            firstName: {
                required,
                onlyCyrSymbol,
            },
            phone: {
                required,
                seemsDigitInPhone: (val) => seemsDigitInPhone(val) && minLength(16)(val),
            },
            isAgree: {
                isAgreed: (val) => val,
            },
        };
    },
    computed: {
        vuelidateErrorMesages() {
            return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
        },
    },
    methods: {
        tryToSend() {
            this.$v.$touch();
            if (this.$v.$anyError) return false;
            this.modalSmsShow = true;
        },
        async onSend() {
            this.isLoading = true;
            const utm = location.search || getCookie('DOMRF_GLOBAL_UTM');
            const data = {
                data: {
                    type: "premiumServiceCallForm",
                    attributes: {
                        name: this.firstName,
                        surname: this.lastName,
                        phone: this.phone.replace(/[\s-()\+]/g, ''), // eslint-disable-line
                        agreement: true
                    }
                }
            };
            if (utm) data.utm = utm;
            const res = await axios.post(`${this.url}?sessid=${this.sessid}`, data).catch((e) => e);
            this.isLoading = false;

            if (res.statusText === 'Created') {
                this.isSended = true;
                window.dmpkitdl.push({event: 'card-premium-consult-lead-fos-send'});
            } else {
                this.errorText = res.data.message;
            }
        },
    },
}
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

.premium-form-callback {
    &__info {
        @include fluid('width', 488px);
        background: $gray-premium-content;

        @include mobile {
            width: 100%;
            background: none;
        }
    }
}
</style>
